export default "__VITE_ASSET___R8$8fnR__"